import { createSelector } from 'reselect'

export const getContract = state => state.pages.contrat

export const getToken = createSelector([
	getContract
], contrat => contrat.token)
